import cmCoinImg from '../assets/cmcoin.webp'
import { formatCoinsNum } from '../lib/format.js'

export default function CoinIcon({ size = 'md', className = '', style = {} }) {
  return (
    <img
      src={cmCoinImg}
      alt="CM COIN"
      className={`cm-coin-icon cm-coin-${size} ${className}`}
      style={style}
      draggable="false"
    />
  )
}

/**
 * Отображение суммы с крупным логотипом CM COIN вместо текста
 */
export function CoinAmount({ amount, size = 'sm', className = '', style = {} }) {
  if (amount === undefined || amount === null) return null
  return (
    <span className={`cm-amount-wrap cm-amount-${size} ${className}`} style={{ display: 'inline-flex', alignItems: 'center', gap: 2, ...style }}>
      <span className="cm-amount-val">{formatCoinsNum(amount)}</span>
      <CoinIcon size={size} />
    </span>
  )
}

